import { Component } from '@angular/core';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrl: './about-page.component.css',
  imports: [MegamenuComponent, FooterComponent]
})
export class AboutPageComponent {
}